
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/api/grid",
      function () {
        return require("private-next-pages/system/api/grid.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/api/grid"])
      });
    }
  